import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getCompanyFileFields } from 'api/company/getCompanyFileFields'
import { companyFileFieldsKey } from './keys'

type UseCompanyFileFieldsQueryData = Awaited<
  ReturnType<typeof getCompanyFileFields>
>
type UseCompanyFileFieldsQueryKey = ReturnType<typeof companyFileFieldsKey>

type UseCompanyFileFieldsQueryOptions = Partial<
  UseQueryOptions<
    UseCompanyFileFieldsQueryData,
    Error,
    UseCompanyFileFieldsQueryData,
    UseCompanyFileFieldsQueryKey
  >
>

export function useCompanyFileFieldsQuery(
  companyId: number,
  fileId: number | undefined,
  options: UseCompanyFileFieldsQueryOptions = {}
) {
  return useQuery({
    ...options,
    enabled: fileId != null && (options.enabled ?? true),
    queryKey: companyFileFieldsKey(companyId, fileId),
    queryFn: () => {
      if (fileId == null) {
        throw new Error('File ID is required')
      }
      return getCompanyFileFields(companyId, fileId)
    },
  })
}
